import { Node } from '@tiptap/pm/model';
import { proxy, ref } from 'valtio';

/**
 * this makes sure we only have one dBlock menu open at a time
 */
export const chatPersonaMenuState = proxy({
  openForNode: null as Node | null,
  close: () => {
    if (chatPersonaMenuState.openForNode) {
      chatPersonaMenuState.openForNode = null;
    }
  },
  open: (node: Node) => {
    chatPersonaMenuState.openForNode = ref(node);
  },
});
